import { TABLE_SETTINGS_STORAGE_PREFIX } from "../hooks/useStoredTableSettings";

export const USER_SELECTED_LOCALE_STORAGE_KEY = "user_selected_locale";
export const PRESERVED_STORAGE_PREFIX = TABLE_SETTINGS_STORAGE_PREFIX;
export const PRESERVED_STORAGE_KEYS = [USER_SELECTED_LOCALE_STORAGE_KEY];

const isPreserved = (key: string): boolean =>
  key.startsWith(PRESERVED_STORAGE_PREFIX) || PRESERVED_STORAGE_KEYS.includes(key);

export const clearStorageKeepingPreferences = () => {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index));
    keys.forEach((key) => {
      if (key && !isPreserved(key)) localStorage.removeItem(key);
    });
  } catch {
    return;
  }
};
